import { Printer } from "lucide-react";
import { useState } from "react";

import BarraPagamentoMobile from "./BarraPagamentoMobile";
import DescontoCupom from "./DescontoCupom";
import DividirDialog from "./DividirDialog";
import DivisaoAtiva from "./DivisaoAtiva";
import FormasPagamento from "./FormasPagamento";
import ListaProdutosPagamento from "./ListaProdutosPagamento";
import TotalAPagar from "./TotalAPagar";
import { Button } from "../../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";

function Titulo({ mesa, rotulo, titulo, onImprimir }) {
  const detalhes = [mesa?.cliente_nome || mesa?.cliente, mesa?.comanda && `Comanda ${mesa.comanda}`].filter(Boolean);
  return (
    <DialogHeader className="px-4 py-3 pr-12 md:px-6 md:py-4 border-b shrink-0 text-left flex-row items-center gap-3 space-y-0">
      <div className="min-w-0 flex-1 space-y-0.5">
        <DialogTitle className="text-base md:text-xl">{titulo || `Fechar mesa${rotulo ? ` ${rotulo}` : ""} — Pagamento`}</DialogTitle>
        {detalhes.length > 0 && <p className="text-xs md:text-sm text-muted-foreground truncate">{detalhes.join(" · ")}</p>}
      </div>
      {/* Conta com o desconto e os pagamentos desta tela, antes de concluir */}
      {onImprimir && (
        <Button variant="outline" size="sm" className="shrink-0" onClick={onImprimir} title="Imprimir fechamento com o desconto desta tela" data-e2e="pagamento-imprimir-fechamento">
          <Printer className="w-4 h-4 md:mr-2" />
          <span className="hidden md:inline">Imprimir fechamento</span>
        </Button>
      )}
    </DialogHeader>
  );
}

function PainelPagamento({ f }) {
  const { total, divisao, desconto, pagamento, produtos, pmVisual } = f;
  return (
    <div className="hidden md:flex flex-1 min-w-0 min-h-0 flex-col">
      <div className="md:flex-1 md:min-h-0 md:overflow-y-auto p-5 lg:p-8 space-y-5">
        <TotalAPagar total={total} parte={divisao.parte} selecionadosQtd={produtos.selecionadosQtd} pmVisual={pmVisual} onEditarParte={divisao.onEditarParte} />
        {divisao.atual && <DivisaoAtiva divisao={divisao.atual} onCancelar={divisao.onCancelar} onEditarParte={divisao.onEditarParte} rotuloInteira={f.textos?.inteira} />}
        {/* Na divisão o desconto já entrou no valor das partes — reaplicar por parte cobraria menos */}
        {!divisao.atual && <DescontoCupom desconto={desconto} subtotal={total.subtotal} />}
        <FormasPagamento pagamento={pagamento} pmVisual={pmVisual} />
      </div>
      {/* Fixo embaixo: com muitos pagamentos no resumo o botão sumia da tela */}
      <div className="px-5 lg:px-8 py-4 border-t shrink-0">
        <Button className="w-full h-16 text-xl font-bold" onClick={pagamento.confirmar} disabled={!pagamento.podeConfirmar}>
          {pagamento.rotuloBotao || (divisao.parte ? `Confirmar parte ${divisao.parte.numero} de ${divisao.parte.total}` : "Confirmar Pagamento")}
        </Button>
      </div>
    </div>
  );
}

/**
 * Popup de pagamento do Fechar mesa. Só apresenta: o estado e as ações
 * (registrar no caixa, imprimir, concluir pedidos) continuam em pages/Mesas.js,
 * que monta o objeto `f`.
 */
export default function FechamentoMesaDialog({ f }) {
  const [dividirAberto, setDividirAberto] = useState(false);
  const { produtos, divisao } = f;
  return (
    <Dialog open={f.open} onOpenChange={f.onOpenChange}>
      {/* Celular: tela cheia, lista rolando e barra de pagamento presa embaixo */}
      <DialogContent className="w-screen max-w-none h-[100dvh] rounded-none sm:rounded-none md:w-[96vw] md:max-w-[1600px] md:h-[92dvh] md:rounded-lg p-0 gap-0 flex flex-col overflow-hidden">
        <Titulo mesa={f.mesa} rotulo={f.mesaRotulo} titulo={f.textos?.titulo} onImprimir={f.onImprimirFechamento} />
        <div className="flex-1 min-h-0 flex flex-col md:flex-row">
          <ListaProdutosPagamento produtos={produtos} divisao={divisao} getImageUrl={f.getImageUrl} textos={f.textos} onAbrirDividir={() => setDividirAberto(true)} />
          <PainelPagamento f={f} />
          <BarraPagamentoMobile f={f} onAbrirDividir={() => setDividirAberto(true)} />
        </div>
        <DividirDialog
          open={dividirAberto}
          onOpenChange={setDividirAberto}
          valor={divisao.valorBase}
          descricao={produtos.selecionadosQtd > 0 ? `${produtos.selecionadosQtd} produto(s) selecionado(s)` : `${f.textos?.inteira || "Mesa inteira"} (o que falta pagar)`}
          temDesconto={divisao.temDesconto}
          onConfirmar={(partes) => { setDividirAberto(false); divisao.onDividir(partes); }}
        />
      </DialogContent>
    </Dialog>
  );
}
